const PPE_INSTAGRAM_FEED_URL =
  'https://ppe-instagram-feed.jaiminppe.workers.dev/feed';

async function loadPPEInstagramFeed(scope = document) {
  const feeds = scope.querySelectorAll(
    'shop-the-feed[data-ppe-instagram-feed="true"]'
  );

  for (const feed of feeds) {
    await loadSinglePPEInstagramFeed(feed);
  }
}

async function loadSinglePPEInstagramFeed(feed) {
  const container = feed.querySelector('.shop-the-feed__items');

  if (!container) return;

  try {
    const response = await fetch(PPE_INSTAGRAM_FEED_URL, {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Feed request failed: ${response.status}`);
    }

    const data = await response.json();

    if (!Array.isArray(data.posts)) {
      throw new Error('Instagram feed returned no posts.');
    }

    container.innerHTML = '';

    data.posts.slice(0, 8).forEach((post, index) => {
      let imageUrl = post.media_url;

      // Videos / Reels should display their thumbnail
      if (post.media_type === 'VIDEO' && post.thumbnail_url) {
        imageUrl = post.thumbnail_url;
      }

      if (!imageUrl || !post.permalink) return;

      const column = document.createElement('div');

      column.className = 'f-column';

      if (feed.dataset.enableSlider === 'true') {
        column.classList.add('swiper-slide');
      }

      column.dataset.index = index;

      const card = document.createElement('stf-card');
      card.className = 'stf-card block';

      const link = document.createElement('a');
      link.href = post.permalink;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.className = 'block';

      const media = document.createElement('div');
      media.className = 'stf-card__media blocks-radius';
      media.style.setProperty('--aspect-ratio', '1/1');

      const imageWrapper = document.createElement('div');
      imageWrapper.className =
        'stf-card__image absolute inset-0 w-full h-full flex flex-col items-center justify-center';

      const image = document.createElement('img');
      image.src = imageUrl;
      image.loading = index < 3 ? 'eager' : 'lazy';
      image.className = 'motion-reduce hover-scale-up';
      image.alt =
        post.caption?.slice(0, 120) ||
        'PPE Supply Canada Instagram post';

      image.style.width = '100%';
      image.style.height = '100%';
      image.style.objectFit = 'contain';

      imageWrapper.appendChild(image);
      media.appendChild(imageWrapper);
      link.appendChild(media);
      card.appendChild(link);
      column.appendChild(card);
      container.appendChild(column);
    });

    // Tell Hyper's existing slider that new slides were inserted
    if (feed.sliderInstance?.slider) {
      feed.sliderInstance.slider.update();
      feed.sliderInstance.slider.slideTo(0, 0);
    }
  } catch (error) {
    console.error('PPE Instagram Feed:', error);

    // Leave the area empty if the live feed cannot be retrieved.
    container.innerHTML = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  loadPPEInstagramFeed();
});

// Supports Shopify theme editor section reloads
document.addEventListener('shopify:section:load', (event) => {
  loadPPEInstagramFeed(event.target);
});